// extracted by mini-css-extract-plugin
export default {"primary-nav-width":"56px","container":"styles_container__6u56K"};